import { render, staticRenderFns } from "./user-role-bind-log.vue?vue&type=template&id=d5c6ab3a&scoped=true&"
import script from "./user-role-bind-log.vue?vue&type=script&lang=js&"
export * from "./user-role-bind-log.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c6ab3a",
  null
  
)

export default component.exports